<template>
  <div class="kd-scale-buttons">
    <div class="kd-scale-buttons__inner-wrapper">
      <div
        class="kd-scale-button kd-scale-button--bigger"
        @click="biggerButtonClicked"
        :style="{
          backgroundImage: `url(${zoomInIcon})`,
        }"
      ></div>
      <div
        class="kd-scale-button kd-scale-button--smaller"
        @click="smallerButtonClicked"
        :style="{
          backgroundImage: `url(${zoomOutIcon})`,
        }"
      ></div>
    </div>
  </div>  
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

import {
  SCALE,
} from '@/store/getter-types';

import {
  SET_SCALE,
} from '@/store/mutation-types';

export default {
  data() {
    return {
      multiplier: 1.2,
      zoomOutIcon: require('../assets/images/icons/zoom-out-1.svg'),
      zoomInIcon: require('../assets/images/icons/zoom-in-1.svg'),
    };
  },
  computed: {
    ...mapGetters([
      SCALE,
    ]),
  },
  methods: {
    ...mapMutations([
      SET_SCALE,
    ]),
    smallerButtonClicked() {
      this.SET_SCALE(this.SCALE / this.multiplier);
    },
    biggerButtonClicked() {
      this.SET_SCALE(this.SCALE * this.multiplier);
    },
  },
};
</script>

<style lang="scss">
.kd-scale-buttons {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  display: flex;
  align-items: center;
  margin-left: 12px;

  .kd--print & {
    display: none;
  }
}

.kd-scale-buttons__inner-wrapper {}

.kd-scale-button {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: white;
  background-position: 7px 7px;
  background-repeat: no-repeat;
  background-size: 16px;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }

  & + & {
    margin-top: 12px;
  }

  @media all and (max-width: 1200px) {
    width: 30px;
    height: 30px;
  }
}
</style>
